import { computed, Injectable, signal } from '@angular/core';
import { AccountInfo } from '@azure/msal-common';
import { CalAngularService } from '@cvx/cal-angular';

export type User = AccountInfo;

interface EmailDetails {
  EMAIL: string;
  PREFERRED_EMAIL: string;
  SHARED_EMAIL: string;
  SUPERVISOR_EMAIL: string;
  SUPERVISOR_PREFERRED_EMAIL: string;
  SUPERVISOR_SHARED_EMAIL: string;
}

@Injectable({
  providedIn: 'root'
})
export class CurrentUserService {
  private currentUserEmail = signal<string | null>(null);
  public readonly email = this.currentUserEmail.asReadonly();

  private _account = signal<User | null>(null);
  
  public get account() {
    return this._account.asReadonly();
  }

  public roles = computed(() => {
    const account = this._account();

    return account?.idTokenClaims?.roles ?? [];
  });

  constructor(private calAngular: CalAngularService) {
    this.setCurrentUserEmail();
    this._getAccount();
  }

  setCurrentUserEmail(): void {
    this.calAngular.getClaims().then(data => {
      if (data && data.email) {
        this.currentUserEmail.set(data.email.toLowerCase());

        // // manually update user email for testing for new endorsers
        // this.currentUserEmail.set('assylzhan.kizbayev1@tengizchevroil.com');
      } else {
        console.warn('No email found in claims data');
        this.currentUserEmail.set(null);
      }
    }).catch(error => {
      console.error('Error getting claims:', error);
      this.currentUserEmail.set(null);
    });
  }

  clearCurrentUserEmail(): void {
    this.currentUserEmail.set(null);
  }

  getCurrentEmail(): string | null {
    return this.currentUserEmail();
  }

  private _getAccount() {
    const user = this.calAngular.getAccount();
    this._account.set(user)
  }
}
